import { Link } from "react-router-dom";
import { SECTIONS } from "@/data/siteContent";
import { SOCIALS } from "@/data/siteContent";

const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-brand-ink text-white mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src="/logo.png" alt="Juventudes Latentes" className="w-10 h-10 rounded-md" />
              <div className="font-heading font-bold text-xl tracking-tight">
                Juventudes <span className="text-gradient">Latentes</span>
              </div>
            </div>
            <p className="mt-4 text-white/60 text-sm leading-relaxed max-w-xs">
              10 años formando liderazgos que transforman a México.
            </p>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.15em] font-semibold text-white/40">
              Navegación
            </p>
            <ul className="mt-3 grid grid-cols-2 gap-x-6 gap-y-2">
              {SECTIONS.filter((s) => !s.hidden).map((s) => (
                <li key={s.key}>
                  <Link
                    to={s.path}
                    data-testid={`footer-${s.key}`}
                    className="text-sm text-white/70 hover:text-brand-lime transition-colors"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.15em] font-semibold text-white/40">
              Síguenos
            </p>
            <ul className="mt-3 space-y-2">
              {SOCIALS.map((soc) => (
                <li key={soc.name}>
                  <a
                    href={soc.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-social-${soc.name.toLowerCase()}`}
                    className="font-heading text-lg font-semibold text-white hover:text-brand-magenta transition-colors"
                  >
                    {soc.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-sm text-white/40">
          <p>© {new Date().getFullYear()} Juventudes Latentes. Todos los derechos reservados.</p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white">
            Acceso administración
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
